import { j as l } from "./AccesRecoveryIcon-CUPieIxT.js";
const i = () => /* @__PURE__ */ l.jsxs("svg", { fill: "none", viewBox: "0 0 315 315", children: [
  /* @__PURE__ */ l.jsx("path", { fill: "#2891F9", d: "m52.5 96.924 105 60.6v40.4l-70-40.4v80.8l-35-20.2z" }),
  /* @__PURE__ */ l.jsx("path", { fill: "#2BBDF7", d: "M87.5 238.324v-80.8l35 20.2v40.4z" }),
  /* @__PURE__ */ l.jsx("path", { fill: "#2B6DEF", d: "m52.5 96.924 35-20.2 105 60.6-35 20.2z" }),
  /* @__PURE__ */ l.jsx("path", { fill: "#2BBDF7", d: "m157.5 157.524 35-20.2v40.4l-35 20.2z" }),
  /* @__PURE__ */ l.jsx("path", { fill: "#2891F9", d: "M192.5 96.924v121.2l35 20.2v-121.2z" }),
  /* @__PURE__ */ l.jsx("path", { fill: "#2BBDF7", d: "m262.5 96.924-35 20.2v121.2l35-20.2z" }),
  /* @__PURE__ */ l.jsx("path", { fill: "#2B6DEF", d: "m227.5 76.724 35 20.2-35 20.2-35-20.2z" })
] });
export {
  i as W
};
